import { useCallback, useEffect, useRef } from "react";

function useTimer(onComplete: () => void, time: number) {
  const start = useRef(time);
  const remaining = useRef(time);
  const timer = useRef<NodeJS.Timeout | undefined>();

  const onClear = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, [timer]);

  const onPause = useCallback(() => {
    onClear();
    remaining.current -= Date.now() - start.current;
  }, [onClear, start, remaining]);

  const onResume = useCallback(() => {
    onClear();
    start.current = Date.now();
    timer.current = setTimeout(onComplete, remaining.current);
  }, [onClear, onComplete, remaining]);

  useEffect(() => {
    onResume();
    return () => {
      onPause();
    };
  }, [onComplete, onPause, onResume]);

  if (!time) {
    return {
      onClear: () => {},
      onPause: () => {},
      onResume: () => {},
    };
  }

  return {
    onClear,
    onPause,
    onResume,
  };
}

export default useTimer;
